import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { DEFAULT_THEME, DEFAULT_KIND, DEFAULT_SIZE } from './configs/config';
import type { TTextComponent } from './models';

/**
 * Старый deprecated компонент в котором много ошибочных комбинаций пропсов
 * они не описаны в дизайне и не описаны в CSS поэтом в каждом таком месте
 * добавлен @ts-ignore
 */
export const Text: FC<React.PropsWithChildren<TTextComponent>> = ({
    Tag,
    children,
    className,
    configs: { fontSize, lineHeight },
    inline = false,
    keepStyles = false,
    kind = DEFAULT_KIND,
    lines = 0,
    marginBottom = true,
    marginTop = true,
    parentType = null,
    priority = 0,
    size = DEFAULT_SIZE,
    styles,
    theme = DEFAULT_THEME,
    ...rest
}) => {
    // @ts-ignore
    const selectedFontSize = fontSize[kind][size];
    // @ts-ignore
    const selectedLineHeight = lineHeight[kind][size];

    const height = lines ? `calc(${lines} * ${selectedLineHeight} * ${selectedFontSize}px)` : null;

    const tagByPriority = priority ? (`h${priority}` as const) : ('p' as const);
    const TagName = Tag ?? (inline ? ('span' as const) : tagByPriority);

    const convertedKind = kind === 'body-text' ? 'body_text' : kind;

    const classNames = cn(
        styles.main,
        {
            // @ts-ignore
            [styles[`${convertedKind}_margin_top_${size}`]]: marginTop && !inline,
            // @ts-ignore
            [styles[`${convertedKind}_margin_bottom_${size}`]]: marginBottom && !inline,
            // @ts-ignore
            [styles[`${convertedKind}_margin_bottom_parent_${parentType}_${size}`]]:
                !inline && marginBottom && kind === 'subtitle' && parentType,
            // @ts-ignore
            [styles[`${convertedKind}_line_height_${size}`]]: !inline,
            // @ts-ignore
            [styles[`${convertedKind}_font_size_${size}`]]: !inline || (inline && keepStyles),
        },
        styles[`${convertedKind}_theme_${theme}`],
        className
    );

    return (
        <TagName className={classNames} style={{ height: height || undefined }} {...rest}>
            {children}
        </TagName>
    );
};
